import axios from "axios";

export async function AddPriorities({ priorities, userDetails }) {
  const URL = process.env.REACT_APP_API_URL;
  const id = userDetails._id;
   console.log(id ,"id id id")
  try {
    const response = await axios.post(
      `${URL}/api/addPriorities/${id}`,
      { priorities },
    );
    return response.data;
  } catch (error) {
    console.error("priorities error:", error);
    throw error;
  }
}
